import { getTermsofUseData } from "../../../app/api/getTermsofUseData";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse, ITermsofUseResponse } from "../../../Orchestrator/Types/Index";


class GetCmsTermsOfUseActon extends BaseAction<ITermsofUseResponse, void> {
  override async run(): Promise<ITermsofUseResponse | null> {
    let termsofUseContent: ITermsofUseResponse | null = null;
    try {
      const response: IApiResponse<ITermsofUseResponse> = await getTermsofUseData();
      if (response.status === "ok" && response.answer) {
        const content = response.answer;
        if (content) {
          termsofUseContent = content
          updateRecoilState("termsofUseContentResponseAtom", termsofUseContent?.data?.terms_of_use);
        } else {
          console.warn("No content available.");
        }
      } else {
        console.warn("Failed to fetch content.");
      }
    } catch (error: any) {
      console.error("Error fetching content:", error);
    } finally {
      return termsofUseContent;
    }
  }
}

export const getCmsTermsOfUseActon = new GetCmsTermsOfUseActon()